import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {Button, Model, RadioButtonField} from 'helpers'
import {IFormField, IRejectionReason} from 'models/Common'
import {useTranslation} from 'react-i18next'
import {fetchRejectionReasons} from 'utils/api/auth/commonService'

type Props = {
 containerClass?: string
 titleClass?: string
 title?: string
 btnClass?: string
 showRejectionModal: boolean
 btnText?: string
 reason: string
 setShowRejectionModal: (show: boolean) => void
 submitRejectionForm: (formData: IFormField) => void
 setLoader: (state: boolean) => void
}

const KTRejectionPopup: React.FC<Props> = (
 props: Props
) => {
 const {t} = useTranslation()
 const [rejectionReasonList, setRejectionReasonList] =
  useState<IRejectionReason[]>([])
 const {
  register,
  handleSubmit,
  watch,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
 })

 async function submitFormData(formData: IFormField) {
  props.submitRejectionForm(formData)
 }

 const getRejectionReasons = async () => {
  props.setLoader(true)
  const res: IRejectionReason[] | null =
   await fetchRejectionReasons(props.reason)
  if (res) {
   setRejectionReasonList(res ?? [])
  }
  props.setLoader(false)
 }

 useEffect(() => {
  if (props.showRejectionModal) {
   void getRejectionReasons()
  }
 }, [props.showRejectionModal])

 return (
  <>
   <Model
    show={props.showRejectionModal}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     props.setShowRejectionModal(false)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {props.title}
      </p>
      <form
       method='POST'
       action=''
       onSubmit={handleSubmit(submitFormData)}
      >
       <div className='w-full my-7'>
        <RadioButtonField
         label={''}
         required={true}
         type='radio'
         wrapperClassName={'max-w-[350px]'}
         className='relative text-[16px] font-medium'
         listItemClassName='flex mb-4 !text-[#33393D] !font-medium'
         id={`rejectionIds`}
         name={`rejectionIds`}
         register={register(`rejectionIds`, {
          validate: {
           required: (v: string) => {
            if (v === '')
             return `${t('helperText.plsSelect')} ${t(
              'userManagement.approvals.reason'
             )}`
           },
          },
          onChange: () => {
           // checkForDependentFields(field)
          },
         })}
         placeholder={''}
         data={rejectionReasonList || []}
         OptionValueKey='id'
         OptionLabelKey='reason'
         errors={errors}
        />
       </div>
       <div className='md:flex items-center justify-center'>
        <Button
         disabled={!watch('rejectionIds')}
         type={'submit'}
         color='red'
         className='text-center w-full py-[9px] px-[24px] !rounded-lg !text-sm text-white font-semibold bg-[#4E83E4]  border-[#4E83E4]'
        >
         {props.btnText}
        </Button>
       </div>
      </form>
     </div>
    </div>
   </Model>
  </>
 )
}

export {KTRejectionPopup}
